import { render, staticRenderFns } from "./FilesDialog.vue?vue&type=template&id=c51e5a30"
import script from "./FilesDialog.vue?vue&type=script&lang=js"
export * from "./FilesDialog.vue?vue&type=script&lang=js"
import style0 from "./FilesDialog.vue?vue&type=style&index=0&id=c51e5a30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports